import { render, staticRenderFns } from "./Program.vue?vue&type=template&id=bda12ca4&scoped=true"
import script from "./Program.vue?vue&type=script&lang=js"
export * from "./Program.vue?vue&type=script&lang=js"
import style0 from "./Program.vue?vue&type=style&index=0&id=bda12ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda12ca4",
  null
  
)

export default component.exports